import React, { useState } from 'react';
import { Tab } from '@mui/material';
import { useTranslation } from 'react-i18next';

import UserCourseHistoryTable from './UserCourseHistoryTable';
import { Container, StyledTabs, TabsWrapper } from './UserCourseHistoryStyled';

const TAB_EXPIRE = 'EXPIRE';
const TAB_STOP = 'STOP';

const UserCourseHistory = ({ user, bigUser }) => {
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState(TAB_EXPIRE);

  const handleChangeTab = (_, newValue) => setSelectedTab(newValue);

  return (
    <Container>
      <TabsWrapper>
        <StyledTabs
          value={selectedTab}
          onChange={handleChangeTab}
          textColor="secondary"
          indicatorColor="secondary"
          aria-label="user course history tabs">
          <Tab value={TAB_EXPIRE} label={t('상품변경 내역')} />
          <Tab value={TAB_STOP} label={t('상품중지 내역')} />
        </StyledTabs>
      </TabsWrapper>

      <UserCourseHistoryTable type={selectedTab} user={user} bigUser={bigUser} />
    </Container>
  );
};

export default UserCourseHistory;
